module.exports = __webpack_public_path__ + "media/images/project/reward/r30000-cbec7fc624a672fbbef289adf090b292.jpg";